import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
export default function FileSelector({
  multiple = true,
  types,
  onChange,
  data,
}) {
  const [dragover, setDragover] = useState(false);
  const [files, setFiles] = useState(data || []);

  useEffect(() => {
    if (onChange) onChange(files);
  }, [files]);

  function addFile(file) {
    if (!multiple && files.length >= 1) {
      toast.error('Es kann nur eine Datei hochgeladen werden.');
      return;
    }
    setFiles((prevFiles) => [...prevFiles, file]);
    console.log('Datei hinzugefügt:', file);
  }

  function handleFileDrop(event) {
    event.preventDefault();
    setDragover(false);
    const files = event.dataTransfer.files;
    for (let i = 0; i < files.length; i++) {
      addFile(files[i]);
    }
  }
  function handleFileSelect(event) {
    const files = event.target.files;
    for (let i = 0; i < files.length; i++) {
      addFile(files[i]);
    }
  }

  function openFileSelector() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.multiple = multiple;
    fileInput.accept = types?.join(',') || '*';
    fileInput.onchange = handleFileSelect;
    fileInput.click();
  }

  return (
    <Box>
      {(multiple === true || files.length === 0) && (
        <Box
          sx={{
            color: 'text.secondary',
            borderRadius: 2,
            p: 2,
            mt: 2,
            backgroundColor: dragover ? 'action.focus' : 'background.paper',
            border: '2px dashed',
            borderColor: 'divider',
            textAlign: 'center',
            cursor: 'pointer',
            '&:hover': { backgroundColor: 'action.hover' },
            '&:active': { backgroundColor: 'action.selected' },
            userSelect: 'none',
          }}
          onDrop={handleFileDrop}
          onDragOver={(e) => {
            e.preventDefault();
            setDragover(true);
          }}
          onDragLeave={() => setDragover(false)}
          onClick={openFileSelector}
        >
          {dragover
            ? 'Datei(en) hier ablegen...'
            : multiple
              ? `Bitte lege die geforderten Dateien (${types?.join(', ') || 'alle Dateitypen'}) hier ab oder klicke hier zum Auswählen.`
              : `Bitte lege die geforderte Datei (${types?.join(', ') || 'alle Dateitypen'}) hier ab oder klicke hier zum Auswählen.`}
        </Box>
      )}
    </Box>
  );
}
